import { formatPlural } from '../string'
import { BaseError } from './BaseError'

export class ErrorGroup extends BaseError {
    constructor(public readonly causes: BaseError[]) {
        super({
            cause: new Error(
                `${causes.length} ${formatPlural({
                    value: 'error',
                    count: causes.length,
                })}\r\n ${causes.map((error) => error.message).join('\r\n')}`
            ),
        })
    }
}
